import { prop } from "../../decorators/property";
import { AppSettings } from "../../app-settings";
import { backboneModelProperties } from "../../decorators/backbone-properties";

export class PublishingGroup extends Backbone.AssociatedModel {

    @prop() public Name: string;
    @prop() public Logo: string;

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/publishing-group.ts